import { Layout, } from "@mcleod/components";

export abstract class AutogenLayoutDemoInputDialog extends Layout {
}
